/* Touch feedback only. Purchase, navigation and click handlers stay native. */
(() => {
  'use strict';
  if (!window.PointerEvent) return;

  let pressed = null;
  let releaseTimer;
  const clear = () => {
    window.clearTimeout(releaseTimer);
    if (pressed) pressed.element.removeAttribute('data-mp-touch-pressed');
    pressed = null;
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    clear();
    if (!event.isPrimary || !(event.target instanceof Element)) return;
    const element = event.target.closest('a, button, [role="button"], input[type="submit"]');
    if (!element || !element.closest('body.mp-taste-v2.mp-solix-palette')) return;
    if (element.matches(':disabled, [aria-disabled="true"]') ||
        element.closest('[inert], [aria-disabled="true"]')) return;
    // Use the CSS marker so new buttons automatically share the existing wipe.
    if (getComputedStyle(element).getPropertyValue('--mp-solix-wipe').trim() !== '1' ||
        getComputedStyle(element, '::before').content === 'none') return;
    pressed = {
      element, id: event.pointerId, x: event.clientX, y: event.clientY,
      started: performance.now()
    };
    element.setAttribute('data-mp-touch-pressed', '');
  }, { passive: true });

  document.addEventListener('pointerup', (event) => {
    if (!pressed || pressed.id !== event.pointerId) return;
    // Let a quick tap finish the 400 ms wipe on actions that stay on this page.
    // Never postpone navigation, submit, or add-to-cart to play an animation.
    releaseTimer = window.setTimeout(clear, Math.max(0, 420 - (performance.now() - pressed.started)));
  }, { passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!pressed || pressed.id !== event.pointerId) return;
    if (Math.hypot(event.clientX - pressed.x, event.clientY - pressed.y) > 10) clear();
  }, { passive: true });
  document.addEventListener('pointercancel', clear, { passive: true });
  document.addEventListener('scroll', clear, { passive: true, capture: true });
  window.addEventListener('blur', clear);
  window.addEventListener('pagehide', clear);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clear();
  });
})();
